import { render } from "./CartPopup.vue?vue&type=template&id=8c97441e&lang=pug"
import script from "./CartPopup.vue?vue&type=script&lang=js"
export * from "./CartPopup.vue?vue&type=script&lang=js"

import "./CartPopup.vue?vue&type=style&index=0&id=8c97441e&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTooltip,QScrollArea,QItem,QRating,QIcon});
